// extracted by mini-css-extract-plugin
export var cardIcon = "_81-5";
export var cardIconUnframed = "_81-9";
export var checkboxCard = "_81-0";
export var checkboxCardSelected = "_81-4";
export var disabled = "_81-2";
export var interactive = "_81-1";
export var outerBorder = "_81-3";
export var spacerMedium = "_81-8";
export var spacerSmall = "_81-7";
export var spacerXsmall = "_81-6";